const FOCUSABLE =
  'input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])';

/** Visual order of the merged personal / vehicle / experience data step. */
export const DATA_STEP_FIELD_ORDER = [
  "fullName",
  "taxId",
  "dateOfBirth",
  "phoneNumber",
  "email",
  "city",
  "spokenLanguages",
  "vehicle",
  "experience",
  "years",
] as const;

/** Visual order of bank fields on the review step. */
export const BANK_FIELD_ORDER = [
  "bankName",
  "bankBranchNumber",
  "bankAccountNumber",
  "bankAccountOwnerName",
  "bankAccountOwnerId",
] as const;

export const firstInvalidFieldKey = (
  errors: Record<string, string>,
  order: readonly string[],
): string | undefined =>
  order.find((key) => Boolean(errors[key])) ?? Object.keys(errors)[0];

/**
 * Scroll the first marked invalid field into the onboarding `<main>` viewport
 * and move keyboard focus onto it. Looks up `[data-field="<key>"]`.
 */
export const scrollToInvalidField = (fieldKey: string): void => {
  const el = document.querySelector<HTMLElement>(
    `[data-field="${fieldKey}"]`,
  );
  if (!el) return;
  el.scrollIntoView({ behavior: "smooth", block: "center" });
  const focusTarget = el.matches(FOCUSABLE)
    ? el
    : el.querySelector<HTMLElement>(FOCUSABLE);
  focusTarget?.focus({ preventScroll: true });
};
